<template>
<el-aside class="sidebar" width="200px">
    <el-menu class="sidebar-el-menu" popper-class="sidebar-el-menu" :default-active="onRoutes"   text-color="#9BA4AB" @select="selectHandle"
      unique-opened router>
      <template v-for="item in menuList">
        <template v-if="item.childs">
          <el-submenu :index="item.path" :key="item.path">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ $lang(item.name) }}</span>
            </template>
            <template v-for="subItem in item.childs">
              <el-submenu
                  v-if="subItem.childs"
                  :index="subItem.path"
                  :key="subItem.path"
              >
                <template slot="title">{{ $lang(subItem.name) }}</template>
                <el-menu-item
                    v-for="(threeItem, i) in subItem.childs"
                    :key="i"
                    :index="threeItem.path"
                >{{ $lang(threeItem.name) }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item v-else :index="subItem.path" :key="subItem.path">{{
                  $lang(subItem.name)
                }}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.path" :key="item.path">
            <i :class="item.icon" style="font-size:18px"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import bus from "../common/bus";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menuList: [
        {
          icon: "icon-iconfont iconfont icon-shouye1",
          path: "/home",
          name: this.$lang("首页"),
          id: '0'
        },
        {
          icon: "icon-iconfont iconfont icon-dingdanluru",
          path: "/orderEntry",
          name: this.$lang("订单录入"),
          id: '1'
        },
        {
          icon: "icon-iconfont iconfont icon-dingdanliebiao",
          path: "/orderList",
          name: this.$lang("订单列表"),
          id: '2'
        },
        {
          icon: "icon-iconfont iconfont icon-kehuguanli",
          path: "/customerManagement",
          name: this.$lang("客户管理"),
          id: '3'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['user']),
    onRoutes() {
      return this.$route.path;
    }
  },
  mounted() {
    if (this.user.staffType === 0) {
      this.$set(this.menuList, this.menuList.length, {
        icon: "icon-iconfont iconfont icon-wodeqianbao",
        path: "/fund-management",
        name: this.$lang("资金管理"),
        id: '4',
        childs: [
          {
            icon: "icon-iconfont iconfont icon-wodeqianbao",
            path: "/advanceCharge",
            name: this.$lang("预付款"),
            id: '5'
          },
          {
            icon: "icon-iconfont iconfont icon-wodeqianbao",
            path: "/accountStatement",
            name: this.$lang("对账单"),
            id: '6'
          }
        ]
      })
    }
  },
  methods: {
    selectHandle(index, indexPath) {
      bus.$emit("routerTitle", indexPath);
    }
  }
};
</script>
<style scoped lang="scss">
.sidebar {
  position: relative;
  display: block;
  overflow-y: scroll;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  box-sizing: border-box;
  // padding-top: 20px;
  background: #ffffff;
  .iconfont {
    font-size: 20px;
    margin-right: 18px;
  }
  ::v-deep .el-submenu__title:hover {
    color: #3BAB89 !important;
    i {
      color: #3BAB89 !important;
    }
  }
  ::v-deep .el-menu-item {
    border-left: 3px solid #fff;
  }
  ::v-deep .el-menu-item {
    &.is-active,
    &:hover,
    &:focus {
      color: #3BAB89 !important;
      font-weight: bolder !important;
      border-left: 3px solid #3BAB89;
      i {
        color: #3BAB89 !important;
      }
    }
  }
  ::v-deep .el-icon-arrow-down:before {
    content: "\e791";
  }
  ::v-deep .el-submenu__icon-arrow {
    top: 32px;
  }
  /*菜单展开*/
  ::v-deep .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    -webkit-transform: rotateZ(90deg);
    -ms-transform: rotate(90deg);
    transform: rotateZ(90deg);
  }
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu {
  border: none;
  background-color: transparent;
  ::v-deep .el-submenu .el-menu-item {
    padding-left: 65px !important;
    // color: #9BA4AB;
  }
  span {
    display: inline-block;
    width: 69%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.sidebar > ul {
  height: 100%;
}
</style>
